<template>
    <div class="date-message">
		<div class="message-item " v-for="item in messages" :key="item.id">
            <div class="datetime">
                {{item.send_at}}
            </div>
            <div class="content">
                <div class="title">
                    {{item.title}}
                    <p>{{item.sub_title}}</p>
                </div>
                <div class="detail">
                    <span class="words">{{item.subtitle}}</span>
                    <div class="row">
                        <span>会议主题：</span>
                        <p>{{item.project}}</p>
                    </div>
                    <div class="row">
                        <span>会议时间：</span>
                        <p>{{item.time_des}}</p>
                    </div>
                    <div class="row">
                        <span>会议地点：</span>
                        <p>{{item.address}}</p>
                    </div>
                    <div class="row">
                        <span>备注：</span>
                        <p>{{item.mark}}</p>
                    </div>
                </div>
                <div class="go-detail" @click="item.url">
                    <span>查看详情</span>
                    <van-icon name="arrow" />
                </div>
            </div>
		</div>
    </div>
</template>
<script>
import {MeetingMessage,PersoanalUserInfo,UserRead} from '../../../config/interface.js'
	export default{
		
		data(){
			return{
				userInfo:'',  //用户信息
                messages:[]
			}
		},
		watch:{
			
		},
        created(){
            if(common.is_weixin()){
                //微信端
				this.getUserInfo();
			}else{
                //非微信端
				this.userInfo=this.$store.state.userInfo;
                if(this.userInfo){

                }
                else{
                    this.$router.replace({
                        path:'/vascularNews/user/login',
                        query:{url:window.location.href}
                    })	
                }
			}
        },
		mounted(){
            
		},
		methods:{
            //得到用户信息
            getUserInfo(){
                const url=PersoanalUserInfo;
                let params={};
                const method='POST';
                fetch(url,params,method)
                .then((res)=>{
                    if(res.code==0){
                        let data=res.data;
                        localStorage.setItem('userInfo',JSON.stringify(data));
                        this.$store.dispatch('storageUserInfo',data);	
                        this.userInfo=data;
                        if(this.userInfo&&this.userInfo.mobile_status==1){
                            this.getMessage();
                        }
                        else{
                            common.toast('未绑定手机',1000,'fail',()=>{
                                 this.$router.replace({
                                    path:'/vascularNews/user/login',
                                    query:{url:window.location.href}
                            })
					        })	
                        }
                    }
                })
            },
			getMessage(){
				const url=MeetingMessage;
				const method='POST'
				let params={};
				fetch(url,params,method)
				.then((res)=>{
					if(res.code==0){
						this.messages=res.data;
                        this.setHasRead();
					}
				})
			},
            setHasRead(){
                const url=UserRead;
				const method='POST'
				let params={
                    type:1
                };
				fetch(url,params,method)
				.then((res)=>{
					if(res.code==0){
					}
				})
            }
		}
		
	}
</script>
<style lang="scss">
.date-message{
    margin-bottom:10px ;
    .datetime{
        text-align: center;
        height: 40px;
        line-height: 40px;
        color: rgb(170, 163, 163);
    }
    .content{
        background: white;
        padding:20px;
        margin:0 10px ;
        border-radius: 0.3rem;
        .title{
            font-size:16px;
            p{
                padding-top:15px;
                color: #666666;
            }
        }
        .detail{
            border-bottom:1px solid rgb(243, 240, 240);
            .words{
                display: block;
                color: #666666;
                font-size:14px;
                margin: 10px 0;
            }
            .row{
                margin-bottom:10px ;
                span{
                    color: #666666;
                    font-size:14px;
                    margin: 10px 0;
                    width:75px;
                    display: inline-block;
                }
                p{
                    display: inline;
                    font-size:14px;
                    color: black
                }
            }
        }
        .go-detail{
            height: 30px;
            color: #666666;
            font-size:14px;
            padding:15px 0 0 0;
            i{
                padding-top: 5px;
                float: right;
            }
        }
    }
	
}
</style>


// WEBPACK FOOTER //
// src/pages/VascularSystem/Message/DateMessage.vue